<template>
  <aside
    :class="[
      'dir-sidebar',
      'd-none',
      'd-lg-block',
      { 'is-collapsed': collapsed }
    ]"
  >
    <div class="dir-sidebar-header">
      <template v-if="!collapsed">
        <i class="el-icon-medal dir-sidebar-icon"></i>
        <span class="dir-sidebar-title">Planes</span>
      </template>
      <button
        class="dir-sidebar-toggle"
        @click="toggleCollapse"
        :title="collapsed ? 'Expandir' : 'Colapsar'"
      >
        <i
          :class="collapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
        ></i>
      </button>
    </div>

    <nav class="dir-sidebar-nav">
      <el-tooltip
        v-for="item in navItems"
        :key="item.key"
        :content="item.label"
        placement="right"
        :disabled="!collapsed"
      >
        <a
          class="dir-sidebar-item"
          :class="{ active: activeTab === item.key }"
          @click="$emit('change-tab', item.key)"
        >
          <i :class="item.icon" class="dir-sidebar-item-icon"></i>
          <span v-if="!collapsed" class="dir-sidebar-item-label">{{
            item.label
          }}</span>
        </a>
      </el-tooltip>
    </nav>
  </aside>
</template>

<script>
const STORAGE_KEY = "mydessk_sidebar_collapsed";

export default {
  name: "PlansSidebar",
  props: {
    activeTab: { type: String, default: "plans" }
  },
  data() {
    return {
      collapsed: localStorage.getItem(STORAGE_KEY) === "true"
    };
  },
  computed: {
    navItems() {
      return [
        {
          key: "plans",
          label: "Planes",
          icon: "el-icon-medal"
        },
        {
          key: "additionals",
          label: "Adicionales",
          icon: "el-icon-circle-plus-outline"
        },
        {
          key: "history",
          label: "Historial",
          icon: "el-icon-time"
        }
      ];
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      localStorage.setItem(STORAGE_KEY, this.collapsed);
    }
  }
};
</script>

<style lang="scss" scoped></style>
